var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:_vm.memberStatus},[_c('span',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.compTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }